import {
  ElConfigProvider,
  ElAlert,
  ElAside,
  ElAutocomplete,
  ElButton,
  ElCard,
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
  ElContainer,
  ElDialog,
  ElDivider,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElForm,
  ElFormItem,
  ElHeader,
  ElIcon,
  ElInput,
  ElInputNumber,
  ElImage,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElOption,
  ElOptionGroup,
  ElPagination,
  ElPopover,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElCol,
  ElRow,
  ElLink,
  ElSubMenu,
  ElSwitch,
  ElTabPane,
  ElTabs,
  ElTable,
  ElTableColumn,
  ElTag,
  ElTooltip,
  ElTransfer,
  ElTree,
  ElUpload,
  ElColorPicker,
  ElDatePicker,
  ElDescriptions,
  ElDescriptionsItem,
  ElEmpty
} from 'element-plus'
const components = [
  ElConfigProvider,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
  ElLink,
  ElCard,
  ElButton,
  ElInput,
  ElForm,
  ElFormItem,
  ElHeader,
  ElIcon,
  ElInputNumber,
  ElAside,
  ElContainer,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElTabPane,
  ElTabs,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElTag,
  ElDialog,
  ElTree,
  ElOption,
  ElOptionGroup,
  ElCol,
  ElRow,
  ElColorPicker,
  ElDatePicker,
  ElSwitch,
  ElPopover,
  ElImage,
  ElDescriptions,
  ElDescriptionsItem,
  ElDivider,
  ElDrawer,
  ElTooltip,
  ElTransfer,
  ElUpload,
  ElAlert,
  ElEmpty,
  ElAutocomplete
]; const options = { size: 'small', zIndex: 3000 }
//  eslint-disable-next-line
const install = function ins(app: any): void {
  // if (install.installed) { return }
  for (let i = 0; i < components.length; i++) {
    app.component(components[i].name, components[i])
  }
  app.config.globalProperties.$ELEMENT = options
}
const API = {
  install
}
export default Object.assign(API, components)
